import { render } from "./ChargeFormView.vue?vue&type=template&id=047dc994"
import script from "./ChargeFormView.vue?vue&type=script&lang=js"
export * from "./ChargeFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__